import { render, staticRenderFns } from "./modalCrearResolucion.vue?vue&type=template&id=e34bff12&scoped=true"
import script from "./modalCrearResolucion.vue?vue&type=script&lang=js"
export * from "./modalCrearResolucion.vue?vue&type=script&lang=js"
import style0 from "./modalCrearResolucion.vue?vue&type=style&index=0&id=e34bff12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34bff12",
  null
  
)

export default component.exports